import { TableBodyCell } from '@pocketlaw/tetris';
import { useProperties } from 'app/domains/global-search/hooks/useProperties';
import { DocumentMetadataPropertyReferenceEnum, DocumentMetadataPropertyTypeEnum, } from 'shared/domains/apollo/generated/types';
import { BooleanCell } from './BooleanCell';
import { DateCell } from './DateCell';
import { MultiLineTextCell } from './MultiLineTextCell';
import { NumberCell } from './NumberCell';
import { SimpleValuesCell } from './SimpleListCell';
import { UsersCell } from './UsersCell';
export function CustomMetadataPropertyCell(props) {
    const { headers, value, columnId } = props;
    const { properties } = useProperties();
    // Metadata fields in search has `metadataDocument` prefix, we remove it to find the property by name
    const property = properties.find((p) => `metadataDocument${p.name}` === columnId);
    switch (property === null || property === void 0 ? void 0 : property.type) {
        case DocumentMetadataPropertyTypeEnum.Boolean:
            return <BooleanCell headers={headers} value={value}/>;
        case DocumentMetadataPropertyTypeEnum.Date:
        case DocumentMetadataPropertyTypeEnum.Datetime:
            return <DateCell headers={headers} date={value}/>;
        case DocumentMetadataPropertyTypeEnum.Number:
            return <NumberCell headers={headers} value={value}/>;
        case DocumentMetadataPropertyTypeEnum.List:
            return (<SimpleValuesCell headers={headers} allowedValues={property.allowedValues || undefined} value={value}/>);
        case DocumentMetadataPropertyTypeEnum.Reference: {
            if (property.reference === DocumentMetadataPropertyReferenceEnum.User) {
                return <UsersCell headers={headers} userIds={value}/>;
            }
            // TODO: Implement component
            return <SimpleValuesCell headers={headers} value={value}/>;
        }
        case DocumentMetadataPropertyTypeEnum.SimpleText:
            return <SimpleValuesCell headers={headers} value={value}/>;
        case DocumentMetadataPropertyTypeEnum.MultiLineText:
            return <MultiLineTextCell headers={headers} text={value}/>;
        default:
            return <TableBodyCell headers={headers}>{value}</TableBodyCell>;
    }
}
